import { TwitterUserInfo } from './TwitterUserInfo';

export function TwitterUserFollowers({
    username,
    className = '',
    format = String,
    fallback = null,
}: {
    username: string;
    className?: string;
    format?: (x: number) => string;
    fallback?: React.ReactNode;
}) {
    return (
        <TwitterUserInfo username={username}>
            {(twitterUserInfo, isLoaded) => {
                if (isLoaded && !twitterUserInfo) return <>{fallback}</>;

                return <span className={className}>{twitterUserInfo?.followers && format(twitterUserInfo.followers)}</span>;
            }}
        </TwitterUserInfo>
    );
}

TwitterUserFollowers.compactFormatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
});
